export var institutionAdminUrl :Array<String> =[
      "",
      "user",
      "changePassword",
      "user/add",
      "dashboard",
      "elearning",
      "elearning/manage",
      "elearning/puzzles",
      "elearning/puzzles/start/:id",
      "sop",
      "sop/create",
      "sop/duplicate/:sopId",
      "sop/duplicate/:sopId/:versionNo",
      "sop/:viewType/:sopId",
      "sop/:viewType/:sopId/:versionNo",
      "institution",
      "institution/view/:id",
      "institution/webKess/:id",
      "user/add",
      "user/addInstitution/:institutionId/:isGroup",
      "user/edit/:userid",
      "user",
      "user/view/:userid",
      "configure",
      "activate",
      "image-institution",
      "sub-category",
      "general",
      "managequota",
      "wards",
      "comments",
      "sopObserve",
      "newObserve",
      "sopObserve/newObserve",
      "observeProtocol",
      "sopObserve/observeProtocol",
      "sopEditor",
      "sopObserve/sopEditor",
      "observeObservationProtocol",
      "observe/observeObservationProtocol",
      "evaluation",
      "evaluation/observeSOP/processCompliance",
      "evaluation/observeSOP/frequencyDistribution",
      "evaluation/observeSOP/subStepCompliance",
      "evaluation/observeSOP/sopComments",
      "evaluation/observeSOP/sopIndividualOverview",
      "evaluation/observeSOP/reportSop",
      "observeObservation/statistical",
      "evaluation/observe/overallCompliance",
      "evaluation/observe/fivemoments",
      "evaluation/observe/quota",
      "evaluation/observe/StatisticsBeforeAsepticProcedures",
      "evaluation/observe/individualOverview",
      "evaluation/observe/comments",
      "evaluation/hygiene-check/statistical",
      "evaluation/hygiene-check/quickComments",
      "evaluation/hygiene-check/complianceQuestions",
      "evaluation/hygiene-check/overallCompliance",
      "evaluation/hygiene-check/individualData",
      "reportSop",
      "evaluation/observeSOP/statistical",
      "statistical",
      "evaluation/consumption",
      "consumption",
      "new",
      "new/start/:period/:Id",
      "new/start/:Id",
      "past",
      "newquota",
      "editquota/:quotaID",
      'profile',
      'reports',
      'overview',
      'users',
      'institutionUsers',
      'exportWebKess',
      'webKessSettings',
      'webKessReports',
      "check-comments",
      'hygiene-check',
      'new-hygiene-check',
      'hygiene-check-editor',
      'questionnaire-editor/:id',
      'questionnaire-viewer/:id',
      'question-manager/:viewType',
      "consumption/statistical",
      "evaluation/consumption/totalConsumption",
      "evaluation/consumption/consumptionPerPatient",
      "edit/:id",
      "view/:id"
    ];
